<section class="pick-card-slider" *ngIf="show" appBackgroundDesign [backgroundDetails]="backgroundDetails">
    <h2>איזה כרטיס אשראי מתאים לך?</h2>
    <h3>בוחרים, מזמינים, צוברים נקודות ונהנים מפינוקים</h3>
    <ng-template #loaderTemplateEl>
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 cards-slick-loader-template">
            <div class="cards-slick-loader-template-cubes-wrapper">
                <div class="cards-slick-loader-template-cube app-loader-blink"></div>
                <div class="cards-slick-loader-template-cube app-loader-blink"></div>
                <div class="cards-slick-loader-template-cube app-loader-blink"></div>
                <div class="cards-slick-loader-template-cube app-loader-blink"></div>
                <div class="cards-slick-loader-template-cube app-loader-blink"></div>
            </div>
        </div>
    </ng-template>

    <div class="slider col-sm-12 col-md-12 col-lg-12 col-xl-12" dir="rtl" *appLoader="isLoaded; template: loaderTemplateEl">
        <ngx-slick-carousel (init)="registrationToGtm($event)" class="center slider" #slickModal="slick-carousel" [config]="sliderConfig" (beforeChange)="uiHelper.IsMobile(768) ? swipeToGtm($event) : false">
            <div ngxSlickItem *ngFor="let cardCategory of cardCategories" appGtm [data]="{category: 'New website - anonymous', action: 'Click on card category', label: cardCategory.HomePageData.Name}" listen="onclick" class="card-details" [routerLink]="[cardCategory.HomePageData.Link]" [queryParams]="{categoryid: cardCategory.Id }">
                <span class="title">{{ cardCategory.HomePageData.Name }}</span>
                <img attr.data-src="{{ cardCategory.HomePageData.Image }}" class="lazyload pic" />
            </div>
        </ngx-slick-carousel>
    </div>
    <div class="order-card-wrapper">
        <div class="get-card-wrapper">
            <a [routerLink]="['/cards/all-cards-wrapper']" [queryParams]="{sourceGA: 'HomepageCardsMarketing'}" class="get-card" title="אני רוצה כרטיס"
               appGtm [data]="{category: 'New website - anonymous', action: 'I want card', label: 'Click'}" listen="onclick"><span>להזמנת כרטיס</span></a>
        </div>
        <span class="piraon-alert">
            אי עמידה בפירעון ההלוואה ו/או האשראי עלולה לגרור חיוב בריבית פיגורים והליכי הוצאה לפועל. כפוף לאישורה של מקס איט פיננסים בע"מ.
        </span>
    </div>
</section>